import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import styled from 'styled-components';
import { Popover } from '@material-ui/core';
import Button from '../../Button';
import { useEmphasis } from '../../utils';
import { filterFromFields, operatorMatchesDataType } from './utils';
import { FilterComponentFactory } from './components/FilterComponentFactory';
var StyledFilterContainer = styled.span.withConfig({
  displayName: "FilterPopover__StyledFilterContainer",
  componentId: "sc-14u876f-0"
})(["margin-left:", ";border-left:", ";padding-left:", ";padding-right:8px;"], function (_ref) {
  var $hasActions = _ref.$hasActions;
  return $hasActions ? '8px' : 0;
}, function (_ref2) {
  var $hasActions = _ref2.$hasActions,
      $color = _ref2.$color;
  return $hasActions ? "1px solid ".concat($color) : 'none';
}, function (_ref3) {
  var $hasActions = _ref3.$hasActions;
  return $hasActions ? '8px' : 0;
});
var StyledCTABar = styled.div.withConfig({
  displayName: "FilterPopover__StyledCTABar",
  componentId: "sc-14u876f-1"
})(["display:flex;justify-content:space-between;"]);
var StyledPopoverContent = styled.div.withConfig({
  displayName: "FilterPopover__StyledPopoverContent",
  componentId: "sc-14u876f-2"
})(["margin:1rem;width:600px;"]);
export var FilterPopover = function FilterPopover(_ref4) {
  var _Object$keys;

  var e2e = _ref4.e2e,
      filterableFields = _ref4.filterableFields,
      hasActions = _ref4.hasActions,
      fields = _ref4.fields,
      setFields = _ref4.setFields,
      setFilter = _ref4.setFilter,
      removeFilter = _ref4.removeFilter;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var emphasis = useEmphasis();
  /* Clears a field value if the new operator is not valid for the input type. */

  var setFieldsGuard = function setFieldsGuard(incomingState) {
    var newState = {};
    Object.entries(incomingState).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          field = _ref6[1];

      var filterField = field;
      newState[key] = _objectSpread(_objectSpread({}, filterField), {}, {
        value: operatorMatchesDataType(filterField) ? filterField.value : ''
      });
    });
    setFields(newState);
  };

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleSubmit = function handleSubmit() {
    setFilter(filterFromFields(fields));
    handleClose();
  };

  var handleClear = function handleClear() {
    removeFilter();
    handleClose();
  };

  var open = Boolean(anchorEl);
  var id = open ? 'simple-popover' : undefined;
  return /*#__PURE__*/React.createElement(StyledFilterContainer, {
    $color: emphasis.contextHigh,
    $hasActions: hasActions
  }, /*#__PURE__*/React.createElement(Button, _extends({}, e2e && {
    e2e: "".concat(e2e, "-table-filter")
  }, {
    "aria-describedby": id,
    variant: "contained",
    icon: open || Object.values(fields).some(function (field) {
      return !!field.value;
    }) ? 'filter_filled' : 'filter',
    tooltip: "Filter",
    dsOnClick: handleClick
  })), /*#__PURE__*/React.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React.createElement(StyledPopoverContent, null, (_Object$keys = Object.keys(fields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (key, index) {
    return /*#__PURE__*/React.createElement(FilterComponentFactory, _extends({}, e2e && {
      e2e: "".concat(e2e, "-table-filter")
    }, {
      type: fields[key].type,
      key: key,
      stateKey: key,
      state: fields,
      filterableField: filterableFields === null || filterableFields === void 0 ? void 0 : filterableFields[index],
      stateChangeFn: setFieldsGuard
    }));
  }), /*#__PURE__*/React.createElement(StyledCTABar, null, /*#__PURE__*/React.createElement(Button, _extends({}, e2e && {
    e2e: "".concat(e2e, "-table-filter-clear")
  }, {
    variant: "outlined",
    dsOnClick: handleClear
  }), "Clear"), /*#__PURE__*/React.createElement(Button, _extends({}, e2e && {
    e2e: "".concat(e2e, "-table-filter-apply")
  }, {
    variant: "contained",
    dsOnClick: handleSubmit
  }), "Apply")))));
};

try {
  FilterPopover.__docgenInfo = {
    description: '',
    displayName: 'FilterPopover',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      filterableFields: {
        defaultValue: null,
        description: '',
        name: 'filterableFields',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      hasActions: {
        defaultValue: null,
        description: '',
        name: 'hasActions',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      fields: {
        defaultValue: null,
        description: '',
        name: 'fields',
        required: true,
        type: {
          name: 'FilterFields'
        }
      },
      setFields: {
        defaultValue: null,
        description: '',
        name: 'setFields',
        required: true,
        type: {
          name: '(fields: any) => void'
        }
      },
      setFilter: {
        defaultValue: null,
        description: '',
        name: 'setFilter',
        required: true,
        type: {
          name: '(filter: any) => void'
        }
      },
      removeFilter: {
        defaultValue: null,
        description: '',
        name: 'removeFilter',
        required: true,
        type: {
          name: '() => void'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map